import { render, staticRenderFns } from "./OtpLogin.vue?vue&type=template&id=13080f90&scoped=true"
import script from "./OtpLogin.vue?vue&type=script&lang=ts"
export * from "./OtpLogin.vue?vue&type=script&lang=ts"
import style0 from "./OtpLogin.vue?vue&type=style&index=0&id=13080f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13080f90",
  null
  
)

export default component.exports